"use client"
import React, { useEffect, useState } from 'react'
// import AOS from 'aos';
import { get } from '@/app/helpers';
import { useTheme } from '@/app/theme-provider';
import Link from 'next/link';
import useFetch from '@/app/useFetch';
import { IMG_URL } from '@/app/config';
const WhatWeDo = () => {
    const {
        theme,
        toggleTheme,
        toggleHighlightLinks,
        highlightLinks,
        language,
        toggleLanguage,
    } = useTheme();
    const [latestUpdate, setLatestUpdates] = useState([])

    // useEffect(() => {
    //     AOS.init({
    //         duration: 1000,
    //         once: false,
    //     });
    //     AOS.refresh();
    // }, []);


    useEffect(() => {
        getLatestUpdates()
    }, [language])

    function getLatestUpdates() {
        get(`website/homepage-latest-updates`).then((res) => {
            setLatestUpdates(res.data)
        }).catch((res) => {

        })
    }

    const { data: footsocialLinks } = useFetch(
        "/website/footer-social-medias",
        // { page, limit: 5 }, // pass page & limit here
        []
    );

    const { data: whatWeDoList } = useFetch(
        "/website/homepage-what-we-do-for-you",
        // { page, limit: 5 }, // pass page & limit here
        []
    );





    return (
        <>
            <section className='cmpad mt-40'>
                <div className='row '>
                    <div className='col-lg-6 col-md-12 col-12'>
                        <h2 className='gradient-text'>{language == "en" ? "What We Do For You!" : "ഞങ്ങൾ നിങ്ങൾക്കായി ചെയ്യുന്നത്!"}</h2>
                        <div className='row gy-3 mt-1'>
                            {whatWeDoList?.length > 0 ? (
                                <>
                                    {whatWeDoList?.length > 0 && (
                                        <>
                                            {whatWeDoList.map((item, index) => {

                                                const isExternal = item.external;

                                                // remove domain for internal routing
                                                const href = isExternal
                                                    ? item.url
                                                    : item.url.replace("https://vigilance.kerala.gov.in", "");

                                                // theme based image
                                                const imageSrc =
                                                    theme === "light"
                                                        ? `${IMG_URL}/${item.lightphoto}`
                                                        : `${IMG_URL}/${item.darkphoto}`;

                                                const Card = (
                                                    <div
                                                        className="about-box"
                                                        // data-aos={index % 2 === 0 ? "flip-left" : "flip-right"}
                                                    >
                                                        <div className="box-top">
                                                            <img src={imageSrc} alt={item.name} />
                                                        </div>

                                                        <p className='box-p'>{item.name}</p>
                                                        <span>{item.description}</span>
                                                    </div>
                                                );

                                                return (
                                                    <div key={item.id} className="col-md-6 col-lg-6 col-12">

                                                        {isExternal ? (
                                                            <a href={href} target="_blank" rel="noopener noreferrer">
                                                                {Card}
                                                            </a>
                                                        ) : (
                                                            <Link href={href}>
                                                                {Card}
                                                            </Link>
                                                        )}

                                                    </div>
                                                );
                                            })}
                                        </>
                                    )}

                                </>
                            ) : null}
                        </div>
                    </div>
                    <div className='col-lg-1 col-md-12 col-12 mt-3 d-none d-lg-block'>
                        <div className="social-bar" >
                            <div className="line"></div>
                            {/* <a href="https://www.facebook.com/vigilancekerala/" target='blank' className="icon facebook">
                                <img src="/icons/facebook.svg" alt='facebook' />
                            </a>
                            <a href="https://www.instagram.com/vigilancekerala/" target='blank' className="icon instagram">
                                <img src="/icons/insta.svg" alt='insta' />
                            </a>
                            <a href="https://x.com/KeralaVigilance" className="icon twitter" target='blank'>
                                <img src="/icons/x.svg" alt='x-icon' />
                            </a>
                            <a href="https://www.youtube.com/@vigilancekearala" target='blank' className="icon youtube">
                                <img src="/icons/youtube.svg" alt='youtube' />
                            </a> */}
                            {footsocialLinks?.map((item, index) => (
                                <a
                                    key={item?.id ?? index}
                                    href={item?.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="icon facebook"
                                >
                                    <img src={`${IMG_URL}${item.photo}`} alt='photo' />
                                </a>
                            ))}
                            <div className="follow-label">FOLLOW US</div>
                        </div>
                    </div>
                    <div className='col-lg-5 col-md-12 col-12 mt-5 mt-md-3 scroll-col-news ' >
                        <div className='latest-update-box'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h2 >{language == "en" ? "Latest Updates" : "ഏറ്റവും പുതിയ അപ്ഡേറ്റുകൾ"}</h2>
                                {/* <button className="view-btn">
                                  
                                </button> */}
                            </div>
                            <p className="text" >
                                {language == "en" ? "Stay informed with the latest news, trends, and updates delivered fresh and fast!" : "ഏറ്റവും പുതിയ വാർത്തകൾ, ട്രെൻഡുകൾ, അപ്‌ഡേറ്റുകൾ എന്നിവയെക്കുറിച്ച് പുതിയതും വേഗത്തിലുള്ളതുമായ വിവരങ്ങൾ എപ്പോഴും അറിഞ്ഞിരിക്കുക!"}
                            </p>
                            {latestUpdate?.length > 0 ? (
                                <>
                                    {latestUpdate?.map((item, index) => {
                                        const date = new Date(item.date);
                                        const card = (
                                            <div className="lu-box">
                                                <div className="row ">
                                                    <div className="col-1 p-0 p-0 d-flex justify-content-start flex-column align-items-center ">
                                                        <div className="date-latest">
                                                            <span>{date.toLocaleDateString("en-US", { day: "numeric", timeZone: "UTC" })}</span>
                                                            <p>{date.toLocaleString("en-US", { month: "short", timeZone: "UTC" })}</p>
                                                        </div>
                                                    </div>
                                                    <div className=" col-10 lu-text d-flex align-items-center">
                                                        <p>{item.name}</p>
                                                    </div>
                                                    <div className="col-1 p-0 d-flex justify-content-start  align-items-center">
                                                        <div className="lu-icons">
                                                            <img src="/icons/arrow_outward.svg" alt='arrow' />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );

                                        return item?.link ? (
                                            <Link key={item?.id ?? index} href={`${item.link}`}>
                                                {card}
                                            </Link>
                                        ) : (
                                            <div key={item?.id ?? index}>{card}</div>
                                        );
                                    })}

                                </>
                            ) : <>
                                <p>No Updates Now</p>
                            </>}

                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default WhatWeDo
